<fidelity-overlay-page-wrapper *transloco="let t; prefix 'fidelity-app'"
    [headerCaption]="t('forgot-pw.heading')"
>
<div
    pageContent
    class="flex flex-col items-center"
    *transloco="let gt"
>
    <div
        class="w-full p-4"
    >
        <div class="mx-auto w-full max-w-3xl">
            <!-- Logo -->
            @if (brandsService.logoUrl) {
                <img
                    class="w-auto mb-4 mx-auto"
                    [src]="brandsService.logoUrl"
                    alt="Logo image"
                />
            }

            <!-- Title -->
            <h2
                class="mt-8"
            >
                {{ t('forgot-pw.title') }}
            </h2>
            <div class="mt-0.5 font-medium">
                {{ t('forgot-pw.description') }}
            </div>

            <!-- Alert -->
            @if (fullErrorMessage()) {
                <tb-dismissable-error
                    [fullErrorMessage]="this.fullErrorMessage()"
                    (onDismiss)="dismissError()"
                ></tb-dismissable-error>
            }

            <!-- Forgot password form -->
            <form
                class="mt-8"
                [formGroup]="forgotPasswordForm"
                #forgotPasswordNgForm="ngForm"
            >
                <!-- Email field -->
                <mat-form-field class="w-full">
                    <mat-label>{{ gt('generic.email') }}</mat-label>
                    <input id="email" matInput [formControlName]="'email'" />
                    @if (forgotPasswordForm.get('email').hasError('required')) {
                        <mat-error> {{ gt('validation.req') }} </mat-error>
                    }
                    @if (forgotPasswordForm.get('email').hasError('email')) {
                        <mat-error> {{ gt('validation.email') }} </mat-error>
                    }
                </mat-form-field>

                <!-- Submit button -->
                <button
                    class="fuse-mat-button-large mt-3 w-full enabled:bg-tb-primary enabled:text-tb-primary-contrast"
                    mat-flat-button
                    [disabled]="forgotPasswordForm.invalid || isLoading()"
                    (click)="sendResetLink()"
                >
                    @if (isLoading()) {
                        <mat-progress-spinner
                            [diameter]="24"
                            [mode]="'indeterminate'"
                        ></mat-progress-spinner>
                    } @else {
                        <span> {{ t('forgot-pw.send-link')}} </span>
                    }
                </button>
            </form>
        </div>
    </div>
</div>
</fidelity-overlay-page-wrapper>
